// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { DesignStudioWeddingRingSuccessNewCustomerFragmentDoc } from './success/designStudioWeddingRingSuccessNewCustomer.fragment.generated';
import { CustomerRegistrationResponseFragmentDoc } from '../../../auth/fragments/customerRegistrationResponse.generated';
import { LoginResponseSuccessFragmentDoc } from '../../../auth/fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../../../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../../fragments/costumerConsultant.fragment.generated';
export const DesignStudioWeddingRingNewCustomerResponseFragmentDoc = `
    fragment designStudioWeddingRingNewCustomerResponse on CatalogueDesignStudioCheckoutWeddingRingNewCustomerResponse {
  ...designStudioWeddingRingSuccessNewCustomer
}
    `;